module.exports = __webpack_public_path__ + "img/mg1.5d420fda.jpg";